// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';
import Stripe                   from 'stripe';

const stripeCreateCustomer = async ({
    test,
    email,
    name,
}: {
    test: boolean,
    email: string,
    name: string,
}): Promise<Stripe.Customer> => {
    const functions = getFunctions();
    const createCustomer = httpsCallable<
        {
            test: boolean,
            email: string,
            name: string,
        },
        Stripe.Customer
    >(
        functions,
        'stripeCreateCustomer',
    );

    return createCustomer({
        test,
        email,
        name,
    }).then((result) => {
        const customer = result.data as Stripe.Customer;
        return customer;
    }).catch((err) => {
        throw err;
    });
};

export default stripeCreateCustomer;
